import { render } from "./SegmentationBlockOR.vue?vue&type=template&id=33092082&scoped=true"
import script from "./SegmentationBlockOR.vue?vue&type=script&lang=ts"
export * from "./SegmentationBlockOR.vue?vue&type=script&lang=ts"

import "./SegmentationBlockOR.vue?vue&type=style&index=0&id=33092082&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-33092082"

export default script